export default "__VITE_ASSET__9EwyzWsB__"